import React, { useState } from 'react';
import './ColorPicker.scss';

const COLOR_OPTIONS = [
    '0A84FF',
    '5EE1FF',
    '34C759',
    '44D7B6',
    'FF5E67',
    'FF9500',
    '7E34C7',
    'B620E0',
];

export function ColorPicker({ selectedColor, onColorSelect, disabled = false }) {
    const [colorPickerOpen, setColorPickerOpen] = useState(false);

    const toggleColorPicker = () => {
        if (!disabled) {
            setColorPickerOpen(!colorPickerOpen);
        }
    };

    const handleColorSelect = (color) => {
        if (!disabled) {
            onColorSelect(color);
            setColorPickerOpen(false);
        }
    };

    const getCssColor = (color) => `#${color}`;

    return (
        <div className="color-dropdown">
            <button 
                className={`color-select-btn has-down-chevron ${disabled ? 'disabled' : ''}`} 
                onClick={toggleColorPicker}
                disabled={disabled}
            >
                <span 
                    className='color-dot' 
                    style={{ backgroundColor: selectedColor ? getCssColor(selectedColor) : '#0A84FF' }}
                />
            </button>

            {colorPickerOpen && !disabled && (
                <div className="color-picker-grid">
                    {COLOR_OPTIONS.map((color) => (
                        <button
                            key={color}
                            className={`color-option-btn ${selectedColor === color ? 'selected' : ''}`}
                            style={{ backgroundColor: getCssColor(color) }}
                            onClick={() => handleColorSelect(color)}
                        />
                    ))}
                </div>
            )}
        </div>
    );
}

export default ColorPicker; 